import { render, staticRenderFns } from "./LetterButton.vue?vue&type=template&id=0c3a4f21&"
import script from "./LetterButton.vue?vue&type=script&lang=js&"
export * from "./LetterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports